import * as i0 from '@angular/core';
import { Injectable, ErrorHandler, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Subject, throwError, BehaviorSubject } from 'rxjs';
import { catchError, tap, finalize, timeout, retryWhen, delay, take, publishReplay, refCount, map } from 'rxjs/operators';
import * as i3 from 'angular-oauth2-oidc';
import * as underscore from 'underscore';
let AppConfig = /*#__PURE__*/(() => {
  class AppConfig extends Subject {
    http;
    config = {};
    externalConfig = null;
    constructor(http) {
      super();
      this.http = http;
    }
    getConfig(key) {
      var value = this.config[key];
      if (value == null && this.externalConfig != null) {
        value = this.externalConfig[key];
        if (value != null) this.config[key] = value;
      }
      return value;
    }
    ///
    /// Bootstrap the environment settings
    ///
    load(url, config) {
      if (config != null) this.config = config;
      return new Promise((resolve, reject) => {
        let sub = this.http.get(url).pipe(catchError(error => {
          console.log('Configuration file "config.json" could not be read');
          resolve(true);
          return throwError(error || 'Server error');
        })).subscribe(envResponse => {
          this.externalConfig = envResponse;
          this.next(this);
          resolve(true);
          sub.unsubscribe();
        });
      });
    }
    ///
    /// Load the real configuration once the bootstrap has been loaded.
    loadConfiguration(config) {
      this.config = config;
    }
    static ɵfac = function AppConfig_Factory(t) {
      return new (t || AppConfig)(i0.ɵɵinject(i1.HttpClient));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AppConfig,
      factory: AppConfig.ɵfac,
      providedIn: 'root'
    });
  }
  return AppConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FoundationConfig = /*#__PURE__*/(() => {
  class FoundationConfig {
    config;
    ApplicationName;
    // LoggingService
    LoggingServiceUrl;
    ErrorLevel;
    ServerError;
    // Sitecore Session Timer
    SitecoreContentServiceUrl;
    SessionTimerContentServiceParameter;
    constructor(config) {
      this.config = config;
      config.subscribe(() => {
        // Logging Service
        this.LoggingServiceUrl = this.BaseMemberServiceUrl + 'logError';
        this.SitecoreContentServiceUrl = this.BaseSitecoreServiceUrl + 'SitecoreContent/';
      });
      this.ErrorLevel = 'Error';
      this.ServerError = 'Server error';
      this.SessionTimerContentServiceParameter = 'SessionTimer';
    }
    // *** Begin constants from configuration json file ***
    get BaseSecureAuthUrl() {
      return this.config.getConfig('BaseSecureAuthUrl');
    }
    get BaseSitecoreServiceUrl() {
      return this.config.getConfig('BaseSitecoreServiceUrl');
    }
    get BaseSitecoreUrl() {
      return this.config.getConfig('BaseSitecoreUrl');
    }
    get BaseMemberPortalUrl() {
      return this.config.getConfig('BaseMemberPortalUrl');
    }
    get BaseMemberServiceUrl() {
      return this.config.getConfig('BaseMemberServiceUrl');
    }
    static ɵfac = function FoundationConfig_Factory(t) {
      return new (t || FoundationConfig)(i0.ɵɵinject(AppConfig));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FoundationConfig,
      factory: FoundationConfig.ɵfac
    });
  }
  return FoundationConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Log {
  Date;
  Thread;
  Level;
  Component;
  Message;
  Exception;
  HostName;
  UserName;
}
const httpOptions$1 = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
let LoggingService = /*#__PURE__*/(() => {
  class LoggingService {
    http;
    configuration;
    authService;
    loggingServiceUrl;
    constructor(http, configuration, authService) {
      this.http = http;
      this.configuration = configuration;
      this.authService = authService;
      this.loggingServiceUrl = configuration.LoggingServiceUrl;
    }
    logError(error) {
      var errorResponse;
      let log = this.createErrorLog(error);
      console.log(error.message + " at \n" + String(error.stack));
      if (this.authService.hasValidAccessToken()) this.http.post(this.loggingServiceUrl, JSON.stringify(log), httpOptions$1).subscribe(res => {
        errorResponse = res;
      });
    }
    createErrorLog(error) {
      let log = new Log();
      log.Date = new Date();
      log.Message = error.message;
      log.HostName = this.configuration.BaseMemberPortalUrl;
      log.Component = this.configuration.ApplicationName;
      log.Exception = String(error.stack);
      log.Level = this.configuration.ErrorLevel;
      log.Thread = "";
      log.UserName = this.getUserName();
      return log;
    }
    getUserName() {
      if (this.authService.getIdentityClaims() != null) {
        let claims = this.authService.getIdentityClaims();
        return claims["sub"];
      } else return '';
    }
    static ɵfac = function LoggingService_Factory(t) {
      return new (t || LoggingService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(FoundationConfig), i0.ɵɵinject(i3.OAuthService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LoggingService,
      factory: LoggingService.ɵfac
    });
  }
  return LoggingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorsHandler = /*#__PURE__*/(() => {
  class ErrorsHandler extends ErrorHandler {
    injector;
    constructor(injector) {
      super();
      this.injector = injector;
    }
    handleError(error) {
      const loggingService = this.injector.get(LoggingService);
      loggingService.logError(error);
    }
    static ɵfac = function ErrorsHandler_Factory(t) {
      return new (t || ErrorsHandler)(i0.ɵɵinject(i0.Injector));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ErrorsHandler,
      factory: ErrorsHandler.ɵfac
    });
  }
  return ErrorsHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HttpResponseHelper {
  static handleError(error) {
    console.error(error);
    return throwError(error || "Server Error");
  }
}
let ErrorService = /*#__PURE__*/(() => {
  class ErrorService {
    errorMessage;
    _error;
    set error(value) {
      this._error = value;
      switch (value) {
        case 500:
          this.errorMessage = "An error has occured. Please contact customer service.";
          break;
        case 401:
          this.errorMessage = "You are unauthorized to access this service. Please contact customer service.";
          break;
        case 503:
          this.errorMessage = "The service is not available. Please contact customer service";
          break;
        case 400:
          this.errorMessage = "An error has occured. Please contact customer service.";
          break;
        case 0:
          this.errorMessage = "An error has occured. Please contact customer service.";
          break;
      }
    }
    get error() {
      return this._error;
    }
    static ɵfac = function ErrorService_Factory(t) {
      return new (t || ErrorService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ErrorService,
      factory: ErrorService.ɵfac
    });
  }
  return ErrorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

//import 'rxjs/add/observable/throw';
let HTTPStatus = /*#__PURE__*/(() => {
  class HTTPStatus {
    requestInFlight$;
    constructor() {
      this.requestInFlight$ = new BehaviorSubject(false);
    }
    setHttpStatus(inFlight) {
      this.requestInFlight$.next(inFlight);
    }
    getHttpStatus() {
      return this.requestInFlight$.asObservable();
    }
    static ɵfac = function HTTPStatus_Factory(t) {
      return new (t || HTTPStatus)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HTTPStatus,
      factory: HTTPStatus.ɵfac
    });
  }
  return HTTPStatus;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HTTPListener = /*#__PURE__*/(() => {
  class HTTPListener {
    status;
    errorService;
    constructor(status, errorService) {
      this.status = status;
      this.errorService = errorService;
    }
    intercept(request, next) {
      if (request.method === 'POST') {
        return next.handle(request).pipe(tap(event => {
          this.status.setHttpStatus(true);
          return event;
        }), catchError(error => {
          this.errorService.error = error.status;
          return throwError(error);
        }), finalize(() => {
          this.status.setHttpStatus(false);
        }), timeout(60000) // add 45 second timeout for POST
        );
      } else {
        return next.handle(request).pipe(tap(event => {
          this.status.setHttpStatus(true);
          return event;
        }), retryWhen(error => {
          //this.errorService.error = error;
          return error.pipe(delay(3000), take(10));
        }), timeout(60000),
        // add 30 second timeout  
        catchError(error => {
          this.errorService.error = error.status;
          return throwError(error);
        }), finalize(() => {
          this.status.setHttpStatus(false);
        }));
      }
    }
    static ɵfac = function HTTPListener_Factory(t) {
      return new (t || HTTPListener)(i0.ɵɵinject(HTTPStatus), i0.ɵɵinject(ErrorService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HTTPListener,
      factory: HTTPListener.ɵfac
    });
  }
  return HTTPListener;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Address {
  address1;
  address2;
  city;
  state;
  zipCode;
  isSafeAtHomeAddress = false;
  hasAcceptedSSAConsent = true;
}
class Email {
  Subject;
  Receiver;
  EmailBody;
}
class SessionTimerSitecoreTemplate {
  SessionTimerHeader;
  SessionTimerOkButtonText;
  SessionTimerTextAfterTimer;
  SessionTimerTextBeforeTimer;
}
class State {
  abbreviation;
  name;
}
let BusyService = /*#__PURE__*/(() => {
  class BusyService {
    busy;
    subject;
    constructor() {
      this.busy = false;
      this.subject = new BehaviorSubject(false);
    }
    emit(busy) {
      this.busy = busy;
      this.subject.next(busy);
    }
    isBusy() {
      return this.subject.asObservable();
    }
    static ɵfac = function BusyService_Factory(t) {
      return new (t || BusyService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BusyService,
      factory: BusyService.ɵfac,
      providedIn: 'root'
    });
  }
  return BusyService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommonService = /*#__PURE__*/(() => {
  class CommonService {
    statesList;
    getStates() {
      this.statesList = [{
        "name": "Alabama",
        "abbreviation": "AL"
      }, {
        "name": "Alaska",
        "abbreviation": "AK"
      }, {
        "name": "American Samoa",
        "abbreviation": "AS"
      }, {
        "name": "Arizona",
        "abbreviation": "AZ"
      }, {
        "name": "Arkansas",
        "abbreviation": "AR"
      }, {
        "name": "California",
        "abbreviation": "CA"
      }, {
        "name": "Colorado",
        "abbreviation": "CO"
      }, {
        "name": "Connecticut",
        "abbreviation": "CT"
      }, {
        "name": "Delaware",
        "abbreviation": "DE"
      }, {
        "name": "District Of Columbia",
        "abbreviation": "DC"
      }, {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
      }, {
        "name": "Florida",
        "abbreviation": "FL"
      }, {
        "name": "Georgia",
        "abbreviation": "GA"
      }, {
        "name": "Guam",
        "abbreviation": "GU"
      }, {
        "name": "Hawaii",
        "abbreviation": "HI"
      }, {
        "name": "Idaho",
        "abbreviation": "ID"
      }, {
        "name": "Illinois",
        "abbreviation": "IL"
      }, {
        "name": "Indiana",
        "abbreviation": "IN"
      }, {
        "name": "Iowa",
        "abbreviation": "IA"
      }, {
        "name": "Kansas",
        "abbreviation": "KS"
      }, {
        "name": "Kentucky",
        "abbreviation": "KY"
      }, {
        "name": "Louisiana",
        "abbreviation": "LA"
      }, {
        "name": "Maine",
        "abbreviation": "ME"
      }, {
        "name": "Marshall Islands",
        "abbreviation": "MH"
      }, {
        "name": "Maryland",
        "abbreviation": "MD"
      }, {
        "name": "Massachusetts",
        "abbreviation": "MA"
      }, {
        "name": "Michigan",
        "abbreviation": "MI"
      }, {
        "name": "Minnesota",
        "abbreviation": "MN"
      }, {
        "name": "Mississippi",
        "abbreviation": "MS"
      }, {
        "name": "Missouri",
        "abbreviation": "MO"
      }, {
        "name": "Montana",
        "abbreviation": "MT"
      }, {
        "name": "Nebraska",
        "abbreviation": "NE"
      }, {
        "name": "Nevada",
        "abbreviation": "NV"
      }, {
        "name": "New Hampshire",
        "abbreviation": "NH"
      }, {
        "name": "New Jersey",
        "abbreviation": "NJ"
      }, {
        "name": "New Mexico",
        "abbreviation": "NM"
      }, {
        "name": "New York",
        "abbreviation": "NY"
      }, {
        "name": "North Carolina",
        "abbreviation": "NC"
      }, {
        "name": "North Dakota",
        "abbreviation": "ND"
      }, {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
      }, {
        "name": "Ohio",
        "abbreviation": "OH"
      }, {
        "name": "Oklahoma",
        "abbreviation": "OK"
      }, {
        "name": "Oregon",
        "abbreviation": "OR"
      }, {
        "name": "Palau",
        "abbreviation": "PW"
      }, {
        "name": "Pennsylvania",
        "abbreviation": "PA"
      }, {
        "name": "Puerto Rico",
        "abbreviation": "PR"
      }, {
        "name": "Rhode Island",
        "abbreviation": "RI"
      }, {
        "name": "South Carolina",
        "abbreviation": "SC"
      }, {
        "name": "South Dakota",
        "abbreviation": "SD"
      }, {
        "name": "Tennessee",
        "abbreviation": "TN"
      }, {
        "name": "Texas",
        "abbreviation": "TX"
      }, {
        "name": "Utah",
        "abbreviation": "UT"
      }, {
        "name": "Vermont",
        "abbreviation": "VT"
      }, {
        "name": "Virgin Islands",
        "abbreviation": "VI"
      }, {
        "name": "Virginia",
        "abbreviation": "VA"
      }, {
        "name": "Washington",
        "abbreviation": "WA"
      }, {
        "name": "West Virginia",
        "abbreviation": "WV"
      }, {
        "name": "Wisconsin",
        "abbreviation": "WI"
      }, {
        "name": "Wyoming",
        "abbreviation": "WY"
      }];
      return this.statesList;
    }
    static ɵfac = function CommonService_Factory(t) {
      return new (t || CommonService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CommonService,
      factory: CommonService.ɵfac
    });
  }
  return CommonService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagerService {
  constructor() {}
  getPager(totalItems, currentPage = 1, pageSize = 5) {
    let totalPages = Math.ceil(totalItems / pageSize);
    let startPage, endPage;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    // create an array of pages to ng-repeat in the pager control
    let pages = underscore.range(startPage, endPage + 1);
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }
}
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
let RestClientService = /*#__PURE__*/(() => {
  class RestClientService {
    http;
    configuration;
    constructor(http, configuration) {
      this.http = http;
      this.configuration = configuration;
    }
    wait;
    handleError(configuration, error) {
      console.error(error);
      return throwError(error || configuration.ServerError);
    }
    get(url) {
      return this.http.get(url).pipe(publishReplay(1), refCount(), catchError(error => this.handleError(this.configuration, error)));
    }
    getWithMap(url) {
      return this.http.get(url).pipe(map(res => {
        return res;
      }), publishReplay(1), refCount(), catchError(error => this.handleError(this.configuration, error)));
    }
    post(url, request) {
      return this.http.post(url, JSON.stringify(request), httpOptions).pipe(catchError(error => this.handleError(this.configuration, error)));
    }
    static ɵfac = function RestClientService_Factory(t) {
      return new (t || RestClientService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(FoundationConfig));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RestClientService,
      factory: RestClientService.ɵfac
    });
  }
  return RestClientService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SessionTimerSitecoreService = /*#__PURE__*/(() => {
  class SessionTimerSitecoreService {
    http;
    configuration;
    sessionTimerContentServiceUrl;
    constructor(http, configuration) {
      this.http = http;
      this.configuration = configuration;
      this.sessionTimerContentServiceUrl = configuration.SitecoreContentServiceUrl + configuration.SessionTimerContentServiceParameter;
    }
    getSessionTimerSitecoreContent() {
      return this.http.get(this.sessionTimerContentServiceUrl).pipe(publishReplay(1), refCount(), catchError(error => HttpResponseHelper.handleError(error)));
    }
    static ɵfac = function SessionTimerSitecoreService_Factory(t) {
      return new (t || SessionTimerSitecoreService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(FoundationConfig));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SessionTimerSitecoreService,
      factory: SessionTimerSitecoreService.ɵfac
    });
  }
  return SessionTimerSitecoreService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
** Core module exposing all core views, services, and helpers
*/
const waitCursorServices = [HTTPListener, HTTPStatus];
let PortalCoreModule = /*#__PURE__*/(() => {
  class PortalCoreModule {
    constructor(applicationRef) {
      // for ng2-bootstrap-modal in angualar 5
      //Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
    }
    static ɵfac = function PortalCoreModule_Factory(t) {
      return new (t || PortalCoreModule)(i0.ɵɵinject(i0.ApplicationRef));
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PortalCoreModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [waitCursorServices, {
        provide: HTTP_INTERCEPTORS,
        useClass: HTTPListener,
        multi: true
      }, ErrorService, LoggingService, {
        provide: ErrorHandler,
        useClass: ErrorsHandler
      }, PagerService, BusyService]
    });
  }
  return PortalCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Address, AppConfig, BusyService, CommonService, Email, ErrorService, ErrorsHandler, FoundationConfig, HTTPListener, HTTPStatus, HttpResponseHelper, Log, LoggingService, PagerService, PortalCoreModule, RestClientService, SessionTimerSitecoreService, SessionTimerSitecoreTemplate, State };
